import { render, staticRenderFns } from "./Dynamic.vue?vue&type=template&id=16dfb272"
import script from "./Dynamic.vue?vue&type=script&lang=js"
export * from "./Dynamic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports